import { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'
import { IconProps } from '@/root/shared-types/ui/ui-types'

export const DangerGoodsIcon: FC<IconProps> = ({ width = 24, height = 24, ...rest }) => (
  <Icon type="DangerGoods" width={width} height={height} alt="danger goods" {...rest} />
)
